// AppCard.jsx
import "./Card.scss";

function AppCard({ children, onClick, backgroundColor, accent = "brand" }) {
  return (
    <div
      onClick={onClick}
      className={`hallapp-card ${onClick ? "is-clickable" : ""} accent-${accent}`}
      style={{ backgroundColor }}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="card-body">{children}</div>
    </div>
  );
}

export default AppCard;